/**
 * Api errors reported by the STT controller
 */
export var SttErrorCode;
(function (SttErrorCode) {
    /**
     * Requested STT for a recording that already has STT
     */
    SttErrorCode["RecordingAlreadyHasStt"] = "stt/RecordingAlreadyHasStt";
    /**
     * Failed to create initial stt state for a recording
     */
    SttErrorCode["FailedToCreateInitialSttState"] = "stt/FailedToCreateInitialSttState";
    /**
     * Requested to regenerate STT for a recording that does not have STT
     */
    SttErrorCode["RecordingDoesNotHaveStt"] = "stt/RecordingDoesNotHaveStt";
    /**
     * Requested to regenerate STT for a recording that has STT in progress
     */
    SttErrorCode["SttStillInProgressForRecording"] = "stt/SttStillInProgressForRecording";
    /**
     * Failed to delete stt for a recording
     */
    SttErrorCode["FailedToDeleteStt"] = "stt/FailedToDeleteStt";
})(SttErrorCode || (SttErrorCode = {}));
